export default __webpack_public_path__ + "static/media/about.9405d76c.png";